import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Importation des fichiers de traduction
import fr from './locales/fr.json';
import en from './locales/en.json';
import es from './locales/es.json';
import zh from './locales/zh.json';

// Configuration de base d'i18next
i18n
  // Détection automatique de la langue du navigateur
  .use(LanguageDetector)
  // Intégration avec React
  .use(initReactI18next)
  // Initialisation avec les options
  .init({
    debug: process.env.NODE_ENV === 'development',
    fallbackLng: 'fr',
    supportedLngs: ['fr', 'en', 'es', 'zh'],
    
    // Ressources de traduction
    resources: {
      fr: { translation: fr },
      en: { translation: en || {} },  // Fallback si le fichier n'existe pas encore
      es: { translation: es || {} },  // Fallback si le fichier n'existe pas encore
      zh: { translation: zh || {} }   // Fallback si le fichier n'existe pas encore
    },
    
    // Options d'interpolation
    interpolation: {
      escapeValue: false, // Non nécessaire avec React
    },
    
    // Options de détection de langue
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    
    // Options React
    react: {
      useSuspense: false,
    },
  });

// Fonction utilitaire pour changer la langue
export const changeLanguage = (lng) => {
  return i18n.changeLanguage(lng);
};

// Fonction pour obtenir la liste des langues disponibles
export const getAvailableLanguages = () => {
  return [
    { code: 'fr', name: 'Français', flag: '🇫🇷' },
    { code: 'en', name: 'English', flag: '🇬🇧' },
    { code: 'es', name: 'Español', flag: '🇪🇸' },
    { code: 'zh', name: '中文', flag: '🇨🇳' },
  ];
};

export default i18n;
